
(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else fn();
  }

  ready(function () {
    const widget = document.querySelector(".stacked-subscription-widget");
    if (!widget) return;

    // Hide subscription selector (A/B test requirement)
    const style = document.createElement("style");
    style.textContent = `.stacked-subscription-widget .subscription-options{display:none!important;}`;
    document.head.appendChild(style);

    const productId = widget.dataset.productId;
    const purchaseRadios = widget.querySelectorAll(`input[name="purchase_${productId}"]`);
    const variantItems = Array.from(widget.querySelectorAll(".variant-options .option-item"));
    const subscriptionItems = Array.from(widget.querySelectorAll(".subscription-options .option-item"));
    const onetimePriceEl = widget.querySelector(".onetime-price");
    const onetimeCompareEl = widget.querySelector(".onetime-compare");
    const subscriptionPriceEl = widget.querySelector(".subscription-price");
    const fromLabel = (subscriptionPriceEl?.dataset?.fromLabel || "Fra").trim();

    if (subscriptionItems.length === 0 || variantItems.length === 0) return;

    let currentType =
      widget.querySelector(`#purchase-subscription-${productId}`)?.checked
        ? "subscription"
        : "onetime";

    let currentVariantId =
      widget.dataset.defaultVariantId ||
      widget.querySelector(".variant-options .option-item.active")?.dataset.variantId ||
      (variantItems[0] ? variantItems[0].dataset.variantId : null);

    let currentSellingPlan = null;
    let hasVariantBeenClicked = false;

    // -----------------------------
    // Money formatting
    // -----------------------------
    function formatMoney(cents) {
      if (typeof window.formatMoney === "function" && window.MinimogSettings?.money_format) {
        return window.formatMoney(cents, window.MinimogSettings.money_format);
      }

      const currency =
        window.Shopify?.currency?.active ? window.Shopify.currency.active : "DKK";

      let locale = "da-DK";
      if (currency === "EUR") locale = "en-IE";
      else if (currency === "GBP") locale = "en-GB";
      else if (currency === "USD") locale = "en-US";
      else if (currency === "PLN") locale = "pl-PL";

      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format((parseInt(cents || "0", 10) || 0) / 100);
    }

    function setActiveVariantUI(variantId) {
      variantItems.forEach((el) =>
        el.classList.toggle("active", el.dataset.variantId == variantId)
      );
    }

    function setActiveSubscriptionUI(planId) {
      subscriptionItems.forEach((el) =>
        el.classList.toggle("active", el.dataset.planId == planId)
      );
    }

    function syncOnetimeHeaderToVariant(variantId) {
      if (!onetimePriceEl) return;

      const variantEl = variantItems.find((el) => el.dataset.variantId == variantId) || null;
      if (!variantEl) return;

      const cents = parseInt(variantEl.dataset.originalPrice || variantEl.dataset.variantPrice || "0", 10);
      if (cents > 0) onetimePriceEl.textContent = formatMoney(cents);

      if (onetimeCompareEl) {
        const compareCents = parseInt(variantEl.dataset.comparePrice || "0", 10);
        if (compareCents > 0 && compareCents > cents) {
          onetimeCompareEl.textContent = formatMoney(compareCents);
          onetimeCompareEl.style.display = "inline";
        } else {
          onetimeCompareEl.style.display = "none";
        }
      }
    }

    function getVariantQuantityFromEl(itemEl) {
      const quantity = parseInt(itemEl?.dataset?.variantQuantity || "1", 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function calculateSubscriptionPrice(basePrice, adjustment, adjustmentType, quantity) {
      if (!basePrice) return null;

      if (adjustmentType === "percentage") {
        return Math.round(basePrice * (1 - adjustment / 100));
      }

      if (adjustmentType === "fixed_amount") {
        return Math.max(0, basePrice - adjustment * (quantity || 1));
      }

      if (adjustmentType === "price") {
        return adjustment;
      }

      return Math.max(0, basePrice - adjustment);
    }

    // -----------------------------
    // Price calculations
    // -----------------------------
    function computeSubscriptionPriceFromEl(itemEl) {
      if (!itemEl) return null;

      const basePrice = parseInt(itemEl.dataset.basePrice || "0", 10);
      const adjustment = parseInt(itemEl.dataset.priceAdjustment || "0", 10);
      const adjustmentType = itemEl.dataset.adjustmentType || "percentage";

      return calculateSubscriptionPrice(
        basePrice,
        adjustment,
        adjustmentType,
        getVariantQuantityFromEl(itemEl)
      );
    }

    function computeSubscriptionPriceForVariant(variantEl, planEl) {
      if (!variantEl || !planEl) return null;

      const basePrice = parseInt(variantEl.dataset.variantPrice || "0", 10);
      const adjustment = parseInt(planEl.dataset.priceAdjustment || "0", 10);
      const adjustmentType = planEl.dataset.adjustmentType || "percentage";

      return calculateSubscriptionPrice(
        basePrice,
        adjustment,
        adjustmentType,
        getVariantQuantityFromEl(variantEl)
      );
    }

    function findBestPlanElForVariant(variantId) {
      if (!variantId) return subscriptionItems[0] || null;

      // prefer match by data-variant-id
      let match = subscriptionItems.find((el) => el.dataset.variantId == variantId);

      // fallback by index
      if (!match) {
        const idx = variantItems.findIndex((v) => v.dataset.variantId == variantId);
        if (idx >= 0 && subscriptionItems[idx]) match = subscriptionItems[idx];
      }

      return match || subscriptionItems[0] || null;
    }

    function syncSubscriptionHeaderToMinPrice() {
      if (!subscriptionPriceEl) return;

      let minPrice = null;

      variantItems.forEach((variantEl) => {
        const planEl = findBestPlanElForVariant(variantEl.dataset.variantId);
        const price = computeSubscriptionPriceForVariant(variantEl, planEl);
        if (price === null) return;
        if (minPrice === null || price < minPrice) minPrice = price;
      });

      if (minPrice !== null) {
        subscriptionPriceEl.textContent = `${fromLabel} ${formatMoney(minPrice)}`;
      }
    }

    // ✅ Always update the subscription header based on current variant
    function syncSubscriptionHeaderToVariant(variantId) {
      if (!subscriptionPriceEl) return;

      const variantEl = variantItems.find((el) => el.dataset.variantId == variantId) || null;
      const planEl = findBestPlanElForVariant(variantId);
      if (!variantEl || !planEl) return;

      const price = computeSubscriptionPriceForVariant(variantEl, planEl);
      if (price === null) return;

      subscriptionPriceEl.textContent = formatMoney(price);

      // Only lock plan when subscription is selected
      if (currentType === "subscription") {
        currentSellingPlan = planEl.dataset.planId;
        setActiveSubscriptionUI(currentSellingPlan);
      }
    }

    // -----------------------------
    // ✅ NEW: Update variant option prices when subscription is selected
    // -----------------------------
    function cacheOriginalVariantPrices() {
      variantItems.forEach((v) => {
        // store original cents (one-time) once
        if (!v.dataset.originalPrice) {
          v.dataset.originalPrice = v.dataset.variantPrice || "";
        }
      });
    }

    function applyOnetimePricesToVariantOptions() {
      variantItems.forEach((v) => {
        const priceMain = v.querySelector(".price-main");
        if (!priceMain) return;

        const cents = parseInt(v.dataset.originalPrice || v.dataset.variantPrice || "0", 10);
        if (cents) priceMain.textContent = formatMoney(cents);
      });
    }

    function applySubscriptionPricesToVariantOptions() {
      variantItems.forEach((v) => {
        const priceMain = v.querySelector(".price-main");
        if (!priceMain) return;

        const variantId = v.dataset.variantId;
        const planEl = findBestPlanElForVariant(variantId);
        const subCents = computeSubscriptionPriceForVariant(v, planEl);

        if (subCents !== null) {
          priceMain.textContent = formatMoney(subCents);
        }
      });
    }

    // -----------------------------
    // Init
    // -----------------------------
    cacheOriginalVariantPrices();

    if (currentVariantId) {
      setActiveVariantUI(currentVariantId);
      syncOnetimeHeaderToVariant(currentVariantId);
    }

    syncSubscriptionHeaderToMinPrice();

    // Ensure the first selector shows correct prices based on current type
    if (currentType === "subscription") {
      applySubscriptionPricesToVariantOptions();
      // also lock plan
      const planEl = findBestPlanElForVariant(currentVariantId);
      if (planEl) {
        currentSellingPlan = planEl.dataset.planId;
        setActiveSubscriptionUI(currentSellingPlan);
      }
    } else {
      applyOnetimePricesToVariantOptions();
    }

    // -----------------------------
    // Events
    // -----------------------------
    purchaseRadios.forEach((r) => {
      r.addEventListener("change", function () {
        currentType = this.value;

        if (!currentVariantId && variantItems[0]) {
          currentVariantId = variantItems[0].dataset.variantId;
        }

        if (currentVariantId) {
          setActiveVariantUI(currentVariantId);
          syncOnetimeHeaderToVariant(currentVariantId);
          if (hasVariantBeenClicked) {
            syncSubscriptionHeaderToVariant(currentVariantId);
          } else {
            syncSubscriptionHeaderToMinPrice();
          }
        }

        if (currentType === "subscription") {
          applySubscriptionPricesToVariantOptions();

          // lock selling plan for current variant
          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
          }
        } else {
          // ✅ revert option prices to one-time prices
          currentSellingPlan = null;
          applyOnetimePricesToVariantOptions();
        }
      });
    });

    variantItems.forEach((item) => {
      item.addEventListener("click", function () {
        hasVariantBeenClicked = true;
        currentVariantId = this.dataset.variantId;
        setActiveVariantUI(currentVariantId);
        syncOnetimeHeaderToVariant(currentVariantId);

        // Always keep subscription header synced
        syncSubscriptionHeaderToVariant(currentVariantId);
        
        // Also sync subscription prices display to current variant
        if (currentType === "subscription") {
          applySubscriptionPricesToVariantOptions();

          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
            const price = computeSubscriptionPriceForVariant(this, planEl);
            if (price !== null && subscriptionPriceEl) {
              subscriptionPriceEl.textContent = formatMoney(price);
            }
          }
        }
      });
    });

    // -----------------------------
    // Hijack add-to-cart to avoid old "choose plan" alert
    // -----------------------------
    document.addEventListener(
      "click",
      async function (e) {
        const btn = e.target.closest('button[name="add"]');
        if (!btn) return;

        const form = btn.closest("form");
        if (!form || !widget) return;

        if (!currentVariantId) return;

        if (currentType === "subscription") {
          const planEl = findBestPlanElForVariant(currentVariantId);
          if (planEl) {
            currentSellingPlan = planEl.dataset.planId;
            setActiveSubscriptionUI(currentSellingPlan);
          }
          if (!currentSellingPlan) return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        btn.style.opacity = "0.7";
        btn.style.pointerEvents = "none";

        const qtyInput =
          form.querySelector('input[name="quantity"]') ||
          document.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

        const item = {
          id: currentVariantId,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        };

        if (currentType === "subscription") item.selling_plan = currentSellingPlan;

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: [item] }),
          });

          const data = await res.json();

          if (typeof Shopify !== "undefined" && Shopify.onItemAdded) {
            Shopify.onItemAdded(data);
          } else {
            document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
          }
        } catch (err) {
          console.error("A/B add to cart error:", err);
          alert("Der opstod en fejl. Prøv igen.");
        } finally {
          btn.style.opacity = "1";
          btn.style.pointerEvents = "auto";
        }
      },
      true
    );
  });
})();